module.exports = "<div ng-show=showInvoiceNonEditableFields() kt-non-editable-payment-codes=::tripDetails></div><div ng-if=isVisible() class=traveller-information><div kt-payment-codes-container=tripCheckoutPaymentCodesCtrl.model kt-payment-codes-container-trip-details=tripDetails></div></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/trip/payment-codes/checkout.paymentCodes.tmpl.html
// module id = 3300
// module chunks = 0